import React, { useState } from 'react';
import { Button } from '@material-ui/core';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as InitMapStore from '../../../redux/store/init-map/init-map.store';
import * as InitMapConfig from '../config/config';
import ConfirmModalView from '../../../components/confirm-modal/confirm-modal';
import NotificationService from '../../../common/notification-service';

function SaveDataToDataBaseButton(props) {
    const [openModal, setOpenModal] = useState(false);
    const handleSaveMap = async () => {
        if (props.initMap.mapSetting.name) {
            let MapDataUpdate = InitMapConfig.ConverDataFromStoreToCreateMapUpdateObject(props.initMap);
            MapDataUpdate = formatMapData(MapDataUpdate);
            if (MapDataUpdate.id) { if (await props.UpdateMap(MapDataUpdate)) props.handleClick(); } else { if (await props.PostCreateMap(MapDataUpdate)) props.handleClick(); }
        } else NotificationService.error('Tên bản đồ không được để trống')
    }

    const formatMapData = (MapDataUpdate) => {
        MapDataUpdate.map_setting.map((setting) => {
            if(setting.type_map == 'LAYER'){
                setting.layer_categories = formatMapDataInfo(setting.layer_categories)
            }
        })
        return MapDataUpdate;
    }

    const formatMapDataInfo = (categoryList) => {
        if(categoryList && Array.isArray(categoryList) && categoryList.length >0){
            for(let i=0;i<categoryList.length;i++){
                let settingList = categoryList[i].layer_settings;
                if(Array.isArray(settingList) && settingList.length >0){
                    for(let j=0;j<settingList.length;j++){
                        if(settingList[j].display == null){
                            settingList[j].display = settingList[j].display_name;
                        }
                        if(settingList[j].filter == null){
                            settingList[j].filter = settingList[j].filter_name;
                        }
                        settingList[j].level = j;
                    }
                }
                categoryList[i].layer_settings = settingList;

                let childrenList = categoryList[i].children;

                if(Array.isArray(childrenList) && childrenList.length >0){
                    categoryList[i].children = formatMapDataInfo(childrenList)
                }
            }
        }
        return categoryList;
    }

    return (
        <React.Fragment>
            <ConfirmModalView open={openModal} handleClose={() => setOpenModal(false)} title="Lưu bản đồ" handleAccept={() => handleSaveMap()} />
            <Button color="inherit" onClick={() => setOpenModal(true)}>
                Lưu
            </Button>
        </React.Fragment>
    )
}

const mapStateToProps = state => ({
    initMap: state.initMap
})

const mapDispatchToProps = dispatch => bindActionCreators({
    UpdateMap: InitMapStore.PutUpdateMap,
    PostCreateMap: InitMapStore.PostCreateMap,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(SaveDataToDataBaseButton)